import type { Bid } from '@/data'
import api from '..'

export interface BidRungConditionPayload {
  field: string
  operator: string
  value: string
}

export interface BidRungPayload {
  partner_id: number
  name: string
  bid_amount: number
  priority: number
  active: boolean
  conditions: BidRungConditionPayload[]
}

export async function createBidRung(payload: BidRungPayload): Promise<Bid> {
  const res = await api.post('/bid-rungs', payload)
  return res.data.data
}
